<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.courseDifficultyAddApplyList.push"
    :query-list="queryList"
  >
    <div slot="header-item">
      <v-select-apply-state
        class="table-filter-select"
        v-model="queryList.apply_state"
        @input="handleApplyStateChange"
        size="small"
        placeholder="审核状态"
      />
    </div>
    <v-column-time value="申请时间"/>
    <v-column-avatar label="申请者"/>
    <el-table-column
      v-if="isAdministrator"
      label="申请门店"
      width="150"
      align="center"
      prop="store_name"
    />
    <el-table-column label="课程难度名称" width="150" align="center" prop="difficulty_name"/>

    <el-table-column label="审核状态" width="150" align="center">
      <template v-slot="{ row }">
        <span
          v-for="applyState in findApplyState(row.apply_state)"
          :class="`${applyState.tagType}-color`"
          :key="`applyStateValue${applyState.value}`"
        >
          {{ applyState.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center" width="244px">
      <template v-slot="{ row }">
        <v-list-button
          name="查看"
          icon="view"
          :to="RouteConfig.courseDifficultyAddApplyDetail.to(row.id)"
        />

        <template v-if="row.apply_state === applyStates.review.value">
          <v-list-button
            v-if="!isAdministrator"
            name="撤销"
            icon="restore"
            @click="handleRevoke(row)"
            :is-loading="isRevokingIds.includes(row.id)"
            :is-last="true"
            message="确定要撤销申请吗？"
          />
        </template>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`course-difficulty-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>申请时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>申请者</span>
              <span>{{ v.nickname }}</span>
            </div>

            <div class="list-item-detail">
              <span>申请门店</span>
              <span>{{ v.store_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>课程难度名称</span>
              <span>{{ v.difficulty_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>审核状态</span>
              <span
                v-for="applyState in findApplyState(v.apply_state)"
                :class="`${applyState.tagType}-color`"
                :key="`applyStateValue${applyState.value}`"
              >
                {{ applyState.name }}
              </span>
            </div>

            <div class="list-item-button">
              <v-list-button
                name="查看"
                icon="view"
                :to="RouteConfig.courseDifficultyAddApplyDetail.to(v.id)"
              />

              <template v-if="v.apply_state === applyStates.review.value">
                <v-list-button
                  v-if="!isAdministrator"
                  name="撤销"
                  icon="restore"
                  @click="handleRevoke(v)"
                  :is-loading="isRevokingIds.includes(v.id)"
                  :is-last="true"
                  message="确定要撤销申请吗？"
                />
              </template>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { applyStates, findApplyState } from '@/enums/applyStates';
import { index, revoke } from '@/api/course-difficulty-add-apply';
import { removeArrayItem } from '@/utils';
import { getLegalQueryList } from '@/utils/formats';

export default {
  name: RouteConfig.courseDifficultyAddApplyList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    queryList: {
      is_asc: 0,
      apply_state: applyStates.review.value,
      page: 1,
      size: 8,
    },
    isLoading: false,
    isRevokingIds: [],
    applyStates,
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findApplyState,
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    handleApplyStateChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    refresh() {
      RouteConfig.courseDifficultyAddApplyList.push(this.queryList);
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      getLegalQueryList(queryList, query);
      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleRevoke({ id }) {
      if (this.isRevokingIds.includes(id)) return;

      this.isRevokingIds.push(id);
      const { isError } = await revoke(id);
      removeArrayItem(this.isRevokingIds, id);
      if (isError) return;

      this.load();
    },
  },
};
</script>
